import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { isEqual } from 'lodash';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { ApiError, Company, Meta } from 'utils/types';

import { companiesTransformer } from '../transformers';
import c from '../utils/constants';

interface Result {
  data: Company[];
  meta: Meta;
}

export default function useGetCompanies(q: { [key: string]: any } = {}) {
  const { enabled = true, ...rest } = q ?? {};
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  const [params, setParams] = useState(q);

  useEffect(() => {
    if (!isEqual(rest, params)) {
      setParams(rest);
    }
  }, [params, rest]);

  return useQuery<Result, ApiError>({
    queryKey: [c.COMPANIES, params],
    queryFn: async () => {
      const api = new Api(args);

      const data: Result = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/contacts/companies/',
            params,
            transformer: companiesTransformer.companies,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/contacts/companies/`,
            params,
            transformer: companiesTransformer.companies,
          },
        }),
      );

      return data;
    },
    enabled,
  });
}
